import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import BaseProgressBar from './BaseProgressBar';

const SheetLoader = ({ className = '' }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className={clsx(className)}>
      <style>
        {`
          @keyframes FadeIn {
            0% {
              width: 0;
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              width: 100%;
              opacity: 1;
            }
          }
        `}
      </style>

      <BaseProgressBar
        widthStyle={{ width: mounted ? '100%' : '0%' }}
        animationClass={mounted ? 'animate-[FadeIn_1.5s_infinite_linear]' : ''}
      />
    </div>
  );
};

SheetLoader.propTypes = {
  className: PropTypes.string,
};

export default SheetLoader;
